/* tslint:disable */
import { MinMaxProductChart2D } from './min-max-product-chart-2d';
import { Coordinates } from './coordinates';

/**
 */
export class ViewProductchart2D {
    minMax?: MinMaxProductChart2D;
    chartTempInterval?: number[];
    valueRecAxis?: Coordinates;
    lfDwellingTime?: number;
    lftimeInterval?: number;
    axisName?: number[];
    imageContour?: string[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-productchart-2d.ts